export const URL_SEARCH_KEY_SAMPLE_APP_ID = "sampleAppId";
export const URL_SEARCH_KEY_EMBED_MODE = "embed";
